import { render, staticRenderFns } from "./PcTruncatedTooltip.vue?vue&type=template&id=761ae339&scoped=true"
import script from "./PcTruncatedTooltip.vue?vue&type=script&lang=js"
export * from "./PcTruncatedTooltip.vue?vue&type=script&lang=js"
import style0 from "./PcTruncatedTooltip.vue?vue&type=style&index=0&id=761ae339&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761ae339",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
